import { removeNull, getSameAttribute } from '@/utils/handleData.js'
import { daysFormat } from '@/filters/index'
export default {
  namespaced: true,
  state: {
    securityFundType: [
      {
        uid: '01',
        securityFundType:
          '完善、改造和维护安全防护设施设备支出(不含"三同时"要求初期投入的安全设施)',
        children: [
          {
            uid: '0101',
            securityFundType: '临时用电系统安全防护'
          },
          {
            uid: '0102',
            securityFundType: '洞口安全防护'
          },
          {
            uid: '0103',
            securityFundType: '临边作业安全防护'
          },
          {
            uid: '0104',
            securityFundType: '机械设备安全防护'
          },
          {
            uid: '0105',
            securityFundType: '高处作业安全防护'
          },
          {
            uid: '0106',
            securityFundType: '交叉作业安全防护'
          },
          {
            uid: '0107',
            securityFundType: '防火安全防护'
          },
          {
            uid: '0108',
            securityFundType: '防爆安全防护'
          },
          {
            uid: '0109',
            securityFundType: '防尘安全防护'
          },
          {
            uid: '0110',
            securityFundType: '防毒安全防护'
          },
          {
            uid: '0111',
            securityFundType: '防雷安全防护'
          },
          {
            uid: '0112',
            securityFundType: '防台风安全防护'
          },
          {
            uid: '0113',
            securityFundType: '防地质灾害安全防护'
          },
          {
            uid: '0114',
            securityFundType: '地下工程安全防护'
          },
          {
            uid: '0115',
            securityFundType: '有害气体监测'
          },
          {
            uid: '0116',
            securityFundType: '通风设施设备'
          },
          {
            uid: '0117',
            securityFundType: '临时安全防护'
          }
        ]
      },
      {
        uid: '02',
        securityFundType:
          '配备、维护、保养应急救援器材、设备支出和应急演练支出',
        children: [
          {
            uid: '0201',
            securityFundType: '配备应急救援器材或设备'
          },
          {
            uid: '0202',
            securityFundType: '维护应急救援器材或设备'
          },
          {
            uid: '0203',
            securityFundType: '保养应急救援器材或设备'
          },
          {
            uid: '0204',
            securityFundType: '应急演练支出'
          }
        ]
      },
      {
        uid: '03',
        securityFundType: '开展重大危险源和事故隐患评估、监控和整改支出',
        children: [
          {
            uid: '0301',
            securityFundType: '重大危险源和事故隐患评估'
          },
          {
            uid: '0302',
            securityFundType: '重大危险源和事故隐患监控'
          },
          {
            uid: '0303',
            securityFundType: '重大危险源和事故隐患整改'
          }
        ]
      },
      {
        uid: '04',
        securityFundType:
          '安全生产检查、评价(不包括新建、改建、扩建项目安全评价)、咨询和标准化建设支出',
        children: [
          {
            uid: '0401',
            securityFundType: '安全生产检查'
          },
          {
            uid: '0402',
            securityFundType: '安全生产评价'
          },
          {
            uid: '0403',
            securityFundType: '安全生产咨询'
          },
          {
            uid: '0404',
            securityFundType: '安全生产标准化建设'
          }
        ]
      },
      {
        uid: '05',
        securityFundType: '配备和更新现场作业人员安全防护用品支出',
        children: [
          {
            uid: '0501',
            securityFundType: '作业人员安全防护用品'
          }
        ]
      },
      {
        uid: '06',
        securityFundType: '安全生产宣传、教育培训支出',
        children: [
          {
            uid: '0601',
            securityFundType: '安全生产宣传'
          },
          {
            uid: '0602',
            securityFundType: '安全生产教育培训'
          }
        ]
      },
      {
        uid: '07',
        securityFundType:
          '安全生产适用的新技术、新标准、新工艺、新装备的推广应用支出',
        children: [
          {
            uid: '0701',
            securityFundType: '新技术推广应用'
          },
          {
            uid: '0702',
            securityFundType: '新标准推广应用'
          },
          {
            uid: '0703',
            securityFundType: '新工艺推广应用'
          },
          {
            uid: '0704',
            securityFundType: '新装备推广应用'
          }
        ]
      },
      {
        uid: '08',
        securityFundType: '安全设施及特种设备检测检验支出',
        children: [
          {
            uid: '0801',
            securityFundType: '安全设施检测检验'
          },
          {
            uid: '0802',
            securityFundType: '特种设备检测检验'
          }
        ]
      },
      {
        uid: '09',
        securityFundType: '其他与安全生产直接相关的支出',
        children: [
          {
            uid: '0901',
            securityFundType: '其他与安全生产直接相关的支出'
          }
        ]
      }
    ], // 安全经费类型
    safetyUseList: [], // 缓存安全经费使用列表
    safetyGoodsList: [], // 缓存安全物资出入库列表
    safetyUsePlan: [], // 缓存某年度编制的所有安全经费使用计划
    currentPlan: {},
    lastPlan: {},
    safetyUseAccount: [],
    currentAccount: {},
    safetyUseCheck: [],
    endMonth: daysFormat(new Date()), //数据截止日期
    deviations: [],
    violations: []
  },
  getters: {
    currentPlanDetails: (state) =>
      state.currentPlan.planDetails ? state.currentPlan.planDetails : [],
    lastPlanDetails: (state) =>
      state.lastPlan.planDetails ? state.lastPlan.planDetails : [],
    safetyPlanDetails: (state) => {
      var safetyPlanDetails = []
      state.safetyUsePlan.forEach((item) => {
        if (item.planDetails) {
          item.planDetails.forEach((detail) => {
            safetyPlanDetails.push(
              Object.assign({}, item, detail, detail.expenseAmount)
            )
          })
        }
      })
      return safetyPlanDetails
    },
    safetyUseDetails: (state) => {
      var safetyUseDetails = []
      state.safetyUseAccount.forEach((item) => {
        if (item.useDetails) {
          item.useDetails.forEach((detail) => {
            safetyUseDetails.push(Object.assign({}, item, detail))
          })
        }
      })
      return safetyUseDetails
    },
    safetyUseList: (state, getters) => {
      var safetyUseList = JSON.parse(JSON.stringify(state.securityFundType))
      safetyUseList.forEach((item) => {
        item.children.forEach((child) => {
          child.planDetails = getters.safetyPlanDetails.filter((item) => {
            return item.expenseName === child.expenseName
          })
          const currentChildPlan = getters.currentPlanDetails.find((plan) => {
            return plan.expenseName === child.securityFundType
          })
          child.totolPlanAmount =
            currentChildPlan && currentChildPlan.expenseAmount
              ? getSameAttribute(currentChildPlan.expenseAmount).addValue
              : 0
          const planAmount = currentChildPlan
            ? JSON.parse(JSON.stringify(currentChildPlan.expenseAmount))
            : {}
          for (const key in planAmount) {
            if (Object.hasOwnProperty.call(planAmount, key)) {
              if (parseInt(key) > new Date(state.endMonth).getMonth()) {
                delete planAmount[key]
              }
            }
          }
          child.planAmount = planAmount
            ? getSameAttribute(planAmount).addValue
            : 0
          child.useDetails = getters.safetyUseDetails.filter((item) => {
            return item.expenseName === child.securityFundType
          })
          const useAmount = child.useDetails.filter((item) => {
            return (
              new Date(item.useDate).getTime() <=
              new Date(state.endMonth).getTime()
            )
          })
          child.useAmount = parseFloat(
            (
              getSameAttribute(useAmount, 'expenseAmount').addValue / 10000
            ).toFixed(4)
          )
          child.deviation = parseFloat(
            (child.planAmount - child.useAmount).toFixed(4)
          )
          child.useCheck =
            Math.abs(child.deviation) > 10
              ? '超出偏差限额10万元，应进行定期安全资金使用核查'
              : '符合规定偏差范围'
          child.isDeviation = Math.abs(child.deviation) > 10 ? true : false
          child.expenditure =
            child.deviation !== 0
              ? (child.deviation > 0 ? '节余' : '超额') +
                Math.abs(child.deviation) +
                '万元'
              : null
          if (state.deviations.length) {
            state.deviations.forEach((dev) => {
              if (child.securityFundType === dev.expenseName) {
                child.uid = dev.uid
                child.deviationReason = dev.deviationReason
                child.deviation = dev.deviation
                child.expenditure = dev.expenditure
              }
            })
          }
          child.deviations = child.expenditure
            ? child.securityFundType +
              child.expenditure +
              (child.deviationReason
                ? '，偏差原因为：' + child.deviationReason
                : '')
            : null
        })
        item.totolPlanAmount = getSameAttribute(
          item.children,
          'totolPlanAmount'
        ).addValue
        item.planAmount = getSameAttribute(item.children, 'planAmount').addValue
        item.useAmount = parseFloat(
          getSameAttribute(item.children, 'useAmount').addValue.toFixed(4)
        )
        item.deviation = parseFloat(
          (item.planAmount - item.useAmount).toFixed(4)
        )
        item.readonly = true
        item.useCheck =
          Math.abs(item.deviation) > 10
            ? '超出偏差限额10万元，应进行定期安全资金使用核查'
            : '符合规定偏差范围'
        item.isDeviation = Math.abs(item.deviation) > 10 ? true : false
        item.expenditure =
          item.deviation !== 0
            ? (item.deviation > 0 ? '节余' : '超额') +
              Math.abs(item.deviation) +
              '万元'
            : null
        item.deviationReason = getSameAttribute(
          item.children,
          'deviations',
          '；'
        ).joinString
        item.deviations =
          item.uid +
          '\xa0' +
          item.securityFundType +
          '：' +
          item.deviationReason
      })
      return safetyUseList
    },
    compilePlan: (state, getters) => {
      var compilePlan = JSON.parse(JSON.stringify(state.securityFundType))
      compilePlan.forEach((item) => {
        item.children.forEach((child, index) => {
          if (state.safetyUsePlan.length) {
            const currentChildPlan = getters.currentPlanDetails.find((plan) => {
              return plan.expenseName === child.securityFundType
            })
            const lastChildPlan = getters.lastPlanDetails.find((plan) => {
              return plan.expenseName === child.securityFundType
            })
            if (currentChildPlan) {
              child.uid = currentChildPlan.uid
              child.totol = getSameAttribute(
                currentChildPlan.expenseAmount
              ).addValue
            }
            if (lastChildPlan) {
              child.originaltotol = getSameAttribute(
                lastChildPlan.expenseAmount
              ).addValue
              item.children[index] = Object.assign(
                {},
                child,
                currentChildPlan.expenseAmount,
                getSameAttribute(lastChildPlan.expenseAmount, 'original').newObj
              )
            } else {
              child.originaltotol = 0
              for (let i = 0; i < 12; i++) {
                const key = 'original' + i
                child[key] = 0
              }
              item.children[index] = Object.assign(
                {},
                child,
                currentChildPlan.expenseAmount
              )
            }
          } else {
            child.totol = 0
          }
        })
        item.readonly = true
        for (var i = 0; i < 12; i++) {
          const key = i + ''
          item[key] = getSameAttribute(item.children, key).addValue
          const originalKey = 'original' + key
          item[originalKey] = getSameAttribute(
            item.children,
            originalKey
          ).addValue
        }
        item.totol = getSameAttribute(item.children, 'totol').addValue
        item.originaltotol = getSameAttribute(
          item.children,
          'originaltotol'
        ).addValue
      })
      return compilePlan
    },
    compileUseDetail: (state) => {
      var compileUseDetail = JSON.parse(JSON.stringify(state.securityFundType))
      compileUseDetail.forEach((item) => {
        item.children.forEach((child) => {
          const currentUseDetail = state.currentAccount.useDetails
            ? state.currentAccount.useDetails.find((plan) => {
                return plan.expenseName === child.securityFundType
              })
            : null
          if (currentUseDetail) {
            child.uid = currentUseDetail.uid
            child.expenseAmount = currentUseDetail.expenseAmount
          } else {
            child.expenseAmount = 0
          }
        })
        item.readonly = true
        item.expenseAmount = getSameAttribute(
          item.children,
          'expenseAmount'
        ).addValue
      })
      return compileUseDetail
    }
  },
  mutations: {
    setCurrentPlan(state, params = {}) {
      const lastPlan = state.safetyUsePlan.find((item) => {
        return (
          parseInt(item.adjustPeriod) ===
          parseInt(params.value.adjustPeriod) - 1
        )
      })
      state.currentPlan = params.value
      state.lastPlan = lastPlan ? lastPlan : {}
    },
    setCurrentAccount(state, params = {}) {
      state.currentAccount = params.value
    },
    setDeviations(state, params = {}) {
      state.endMonth = params.value.endMonth
      state.deviations = params.value.checkDetails
        ? params.value.checkDetails
        : []
    },
    setViolations(state, params = {}) {
      state.endMonth = params.value.endMonth
      state.violations = params.value.violationDetails
        ? params.value.violationDetails
        : []
    }
  },
  actions: {
    // 获取安全经费使用列表
    getSafetyUseList({ rootState, commit, dispatch }) {
      var endMonth = ''
      const day = new Date(rootState.queryValues.safetyUse.year + '-12-31')
      if (day.getTime() >= new Date().getTime()) {
        endMonth = daysFormat(new Date())
      } else {
        endMonth = daysFormat(day)
      }
      commit(
        'baseSet',
        {
          module: 'safetyInput',
          key: 'endMonth',
          value: endMonth
        },
        { root: true }
      )
      dispatch('getSafetyUsePlan')
      dispatch('getSafetyUseAccount')
      dispatch('getSafetyUseCheck')
    },
    // 获取安全经费使用计划
    async getSafetyUsePlan({ rootGetters, commit, dispatch }) {
      var queryValues = await dispatch(
        'bidSection/ensureDefaultBidQuery',
        { queryKey: 'safetyUse', fieldKey: 'projectUid' },
        { root: true }
      )
      queryValues = Object.assign({}, queryValues)
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/temp/safefundplan',
          data: queryValues
        },
        { root: true }
      )
      // console.log(res.data)
      var safetyUsePlan = res.data ? res.data : []
      safetyUsePlan.forEach((item) => {
        if (item.adjustPeriod === '0') {
          item.period = '初次计划编制'
        } else {
          item.period = '第' + item.adjustPeriod + '次计划调整'
        }
        if (item.approvalStatus === 0) {
          item.status = '未上报'
          item.disabledButtons =
            rootGetters['user/orgBuildType'] === '总承包单位' ? [] : ['', 1]
        } else if (item.approvalStatus === 1) {
          item.status = '待审批'
          item.disabledButtons =
            rootGetters['user/orgBuildType'] === '总承包单位'
              ? ['', 1, 2, 3]
              : []
        } else if (item.approvalStatus === 3) {
          item.status = '审批通过'
          item.disabledButtons =
            rootGetters['user/orgBuildType'] === '总承包单位'
              ? ['', 1, 2, 3]
              : ['', 1]
        } else if (item.approvalStatus === 4) {
          item.status = '审批拒绝'
          item.disabledButtons =
            rootGetters['user/orgBuildType'] === '总承包单位' ? [] : ['', 1]
        }
      })
      var currentPlan = safetyUsePlan.find((item) => {
        return parseInt(item.adjustPeriod) === safetyUsePlan.length - 1
      })
      var lastPlan = safetyUsePlan.find((item) => {
        return parseInt(item.adjustPeriod) === safetyUsePlan.length - 2
      })
      commit(
        'baseSet',
        {
          module: 'safetyInput',
          key: 'safetyUsePlan',
          value: safetyUsePlan
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'safetyInput',
          key: 'currentPlan',
          value: currentPlan ? currentPlan : {}
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'safetyInput',
          key: 'lastPlan',
          value: lastPlan ? lastPlan : {}
        },
        { root: true }
      )
    },
    // 新增安全经费使用计划
    async addSafetyUsePlan({ state, commit, dispatch }) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/temp/safefundplan',
          data: state.currentPlan,
          msg: '新增安全经费使用计划成功'
        },
        { root: true }
      )
      if (res.code === 200) {
        commit(
          'baseSet',
          {
            module: 'safetyInput',
            key: 'currentPlan',
            value: res.data ? res.data : {}
          },
          { root: true }
        )
      }
      return res
    },
    // 编辑安全经费使用计划
    async editSafetyUsePlan({ state, dispatch }) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/temp/safedetailplan',
          data: state.currentPlan.planDetails,
          msg: '编辑安全经费使用计划成功'
        },
        { root: true }
      )
      return res
    },
    // 上报安全经费使用计划
    async confirmSafetyUsePlan({ state, dispatch }) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/temp/uploadsafefundplan',
          data: { uid: state.currentPlan.uid },
          msg: '上报安全经费使用计划成功'
        },
        { root: true }
      )
      return res
    },
    // 审批安全经费使用计划
    async approveSafetyUsePlan({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/temp/approvesafefundplan',
          data: data,
          msg: '安全经费使用计划审批完成'
        },
        { root: true }
      )
      return res
    },
    // 删除安全经费使用计划
    async deleteSafetyUsePlan({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/temp/safefundplan',
          data: { uid: uid },
          msg: '删除安全经费使用计划成功'
        },
        { root: true }
      )
      return res
    },
    // 获取安全经费使用台帐
    async getSafetyUseAccount({ rootState, commit, dispatch }, data) {
      var queryValues = !data ? rootState.queryValues.safetyUse : data
      queryValues = JSON.parse(JSON.stringify(queryValues))
      queryValues.useType = '安全物资采购,非物资采购'
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/temp/safefundaccount',
          data: queryValues
        },
        { root: true }
      )
      // console.log(res.data)
      var safetyUseAccount = res.data ? res.data : []
      safetyUseAccount.forEach((item) => {
        item.checkReportUid = item.useType === '安全物资采购' ? item.uid : ''
        item.useDate = daysFormat(item.useDate)
        item.detailNum =
          (item.useDetails ? item.useDetails.length : 0) + '条使用明细'
        item.children = item.useDetails ? item.useDetails : []
        item.children.forEach((child) => {
          child.measuredAmount = child.measuredAmount ? child.measuredAmount : 0
          child.measureState = !child.measuredAmount
            ? '未计量'
            : child.expenseAmount === child.measuredAmount
            ? '全部计量'
            : '部分计量'
          child.fundType =
            child.expenseName + '：\xa0' + child.expenseAmount + '元'
        })
        item.measuredAmount = getSameAttribute(
          item.useDetails,
          'measuredAmount'
        ).addValue
        item.measureState = !item.isMeasured
          ? '未计量'
          : !item.measuredAmount
          ? '计量审核中'
          : item.expenseAmount === item.measuredAmount
          ? '全部计量'
          : '部分计量'
        item.fundType = getSameAttribute(
          item.children,
          'fundType',
          '。\n'
        ).joinString
        item.checkStatus = !item.isMeasured
          ? item.checkStatus
          : item.measureState
        item.investAmount = item.investAmount ? item.investAmount : 0
        item.disabledButtons = []
        if (rootState.user.orgValue !== item.orgUid) {
          item.disabledButtons = [0, 1, 2]
        }
        item.hasInvoice = item.invoiceImg ? '是' : '否'
        item.otherEnclosure = item.otherEnclosure ? item.otherEnclosure : []
        commit(
          'pictureSet',
          { key: 'invoiceImg', value: [item.invoiceImg] },
          { root: true }
        )
        commit(
          'pictureSet',
          { key: 'otherEnclosure', value: item.otherEnclosure },
          { root: true }
        )
        item.fileLists = {
          invoiceImg: rootState.pictures.invoiceImg,
          otherEnclosure: rootState.pictures.otherEnclosure
        }
        let srcList = []
        srcList = srcList.concat(
          item.fileLists.invoiceImg,
          item.fileLists.otherEnclosure
        )
        item.srcList = getSameAttribute(srcList, 'url').values
        item.detailForm = [
          { prop: 'accountNum', label: '台帐编号', value: item.accountNum },
          {
            prop: 'useReason',
            label: '使用缘由',
            value: item.useReason,
            span: 10
          },
          { prop: 'useDate', label: '使用时间', value: item.useDate },

          {
            prop: 'useAmount',
            label: '使用金额(元)',
            value: item.useAmount,
            span: 4
          },
          {
            prop: 'useDepartment',
            label: '使用部门',
            value: item.useDepartment,
            span: 5
          },
          { prop: 'usePerson', label: '领用人', value: item.usePerson },
          { prop: 'approver', label: '审批人', value: item.approver },
          {
            prop: 'useType',
            label: '使用类型',
            value: item.useType
          },
          {
            prop: 'hasInvoice',
            label: '是否有发票',
            value: item.hasInvoice,
            span: 4
          },
          {
            prop: 'invoiceImg',
            label: '发票图片',
            value: item.invoiceImg ? item.invoiceNo : '暂无发票',
            drillDown: true,
            span: 5
          },
          {
            prop: 'otherEnclosure',
            label: '其他附件',
            value: item.fileLists.otherEnclosure.length + '个附件',
            drillDown: true
          },
          {
            prop: 'checkReportNo',
            label: '物资验收单编号',
            value: item.checkReportNo,
            drillDown: true,
            span: 14
          }
        ]
      })
      commit(
        'baseSet',
        {
          module: 'safetyInput',
          key: 'safetyUseAccount',
          value: safetyUseAccount
        },
        { root: true }
      )
    },
    // 新增安全经费使用台帐
    async addSafetyUseAccount({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/temp/safefundaccount',
          data: data,
          msg: '添加安全经费使用台帐成功'
        },
        { root: true }
      )
      return res
    },
    // 编辑安全经费使用台帐
    async editSafetyUseAccount({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/temp/safefundaccount',
          data: data,
          msg: '编辑安全经费使用台帐成功'
        },
        { root: true }
      )
      return res
    },
    // 删除安全经费使用台帐
    async deleteSafetyUseAccount({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/temp/safefundaccount',
          data: { uid: uid },
          msg: '删除安全经费使用台帐成功'
        },
        { root: true }
      )
      return res
    },
    // 给安全资金使用台帐添加使用明细
    async addSafetyUseDetails({ state, dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize//temp/safefundaccountdetail',
          data: data ? data : state.currentAccount.useDetails,
          msg: '添加安全资金使用明细成功'
        },
        { root: true }
      )
      return res
    },
    // 编辑安全资金使用明细
    async editSafetyUseDetails({ state, dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize//temp/safefundaccountdetail',
          data: data ? data : state.currentAccount.useDetails,
          msg: '编辑安全资金使用明细成功'
        },
        { root: true }
      )
      return res
    },
    // 获取安全经费核查台帐
    async getSafetyUseCheck({ rootState, state, commit, dispatch }) {
      var queryValues = rootState.queryValues.safetyUse
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/temp/safefundcheck',
          data: queryValues
        },
        { root: true }
      )
      //console.log(res.data)
      var safetyUseCheck = res.data ? res.data : []
      var violations = []
      safetyUseCheck.forEach((item) => {
        item.disabledButtons = []
        if (
          rootState.user.orgValue !== item.orgUid ||
          item.confirmStatus === '已确认'
        ) {
          item.disabledButtons = [0, 1, 2]
        }
        item.period = '第' + item.checkPeriod + '次'
        item.allPerson = getSameAttribute(item.participants).joinString
        item.deviations =
          '共' +
          (item.checkDetails ? item.checkDetails.length : 0) +
          '条使用偏差'
        const unCorrect =
          item.violationDetails && item.violationDetails.length
            ? item.violationDetails.filter((violation) => {
                return !violation.isCorrect
              })
            : []
        item.violations =
          (item.violationDetails && item.violationDetails.length
            ? item.violationDetails.length
            : 0) +
          '条违规项，其中' +
          unCorrect.length +
          '条未整改'
        if (item.violationDetails && item.violationDetails.length) {
          item.violationDetails.forEach((violation) => {
            violation.account = state.safetyUseAccount.find((account) => {
              return account.uid === violation.accountUid
            })
            violation.checkReportUid = violation.account.checkReportUid
            violation.checkReportNo = violation.account.checkReportNo
            violation.orgUid = violation.account.orgUid
            violation.detailForm = violation.account.detailForm
            violation.invoiceImg = getSameAttribute(
              violation.account.fileLists.invoiceImg,
              'url'
            ).values
            violation.otherEnclosure = getSameAttribute(
              violation.account.fileLists.otherEnclosure,
              'url'
            ).values
            violation.srcList = violation.account.srcList
          })
          violations = violations.concat(item.violationDetails)
        }
      })
      commit(
        'baseSet',
        {
          module: 'safetyInput',
          key: 'safetyUseCheck',
          value: safetyUseCheck
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'safetyInput',
          key: 'violations',
          value: violations
        },
        { root: true }
      )
    },
    // 新增安全资金核查台帐
    async addSafetyUseCheck({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/temp/safefundcheck',
          data: data,
          msg: '添加安全资金核查台帐成功'
        },
        { root: true }
      )
      return res
    },
    // 编辑安全资金核查台帐
    async editSafetyUseCheck({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/temp/safefundcheck',
          data: data,
          msg: '编辑安全资金核查台帐成功'
        },
        { root: true }
      )
      return res
    },
    // 删除安全经费核查台帐
    async deleteSafetyUseCheck({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/temp/safefundcheck',
          data: { uid: uid },
          msg: '删除安全经费核查台帐成功'
        },
        { root: true }
      )
      return res
    },
    // 确认安全经费核查台帐
    async confirmSafetyUseCheck({ dispatch }, row) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/temp/checkagree',
          data: { uid: row.uid },
          msg: '确认安全经费核查台帐成功'
        },
        { root: true }
      )
      return res
    },
    // 给安全资金使用台帐添加核查明细
    async addSafetyCheckDetails({ state, dispatch }) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/check/detail',
          data: state.deviations,
          msg: '添加安全资金核查明细成功'
        },
        { root: true }
      )
      return res
    },
    // 编辑安全资金核查明细
    async editSafetyCheckDetails({ state, dispatch }) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/temp/safefundcheckdetail',
          data: state.deviations,
          msg: '编辑安全资金核查明细成功'
        },
        { root: true }
      )
      return res
    },
    // 给安全资金核查添加违规项
    async addSafetyViolations({ state, dispatch }) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/temp/safeillegaldisburse',
          data: state.violations,
          msg: '添加或编辑安全资金核查违规项成功'
        },
        { root: true }
      )
      return res
    },
    // 编辑安全资金核查违规项
    async editSafetyViolations({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/temp/safeillegaldisburse',
          data: data,
          msg: '编辑安全资金核查违规项成功'
        },
        { root: true }
      )
      return res
    },
    // 删除安全资金核查违规项
    async deleteSafetyViolations({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/temp/safeillegaldisburse',
          data: { uid: uid },
          msg: '删除安全经费核查违规项成功'
        },
        { root: true }
      )
      return res
    }
  }
}
